import { render, staticRenderFns } from "./AlterarPlanoContrato.vue?vue&type=template&id=3c280236"
import script from "./AlterarPlanoContrato.vue?vue&type=script&lang=js"
export * from "./AlterarPlanoContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports